import { render, staticRenderFns } from "./SortByData.vue?vue&type=template&id=2f2ec394&"
import script from "./SortByData.vue?vue&type=script&lang=ts&"
export * from "./SortByData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports